module.exports = __webpack_public_path__ + "static/img/7.cf5d857.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/sp/7.png
// module id = QOuH
// module chunks = 0